import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { Link, LinkProps } from 'react-router-dom';

export type LoginLinkProps = Omit<LinkProps, 'to'> & {
  hideIfAuthenticated?: boolean;
};

export const LoginLink = ({ hideIfAuthenticated, ...rest }: LoginLinkProps) => {
  const loginPage = useAppSelector(getSpecialPage('loginPage'));
  const { isAuthenticated } = useAuth();
  let url;
  if (loginPage) {
    url = new URL(loginPage || '');
  }
  const shouldShowLink = url && url.pathname && !(isAuthenticated && hideIfAuthenticated);
  return shouldShowLink ? <Link to={url?.pathname ?? ''} {...rest} /> : null;
};
